import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Avatar,
  Divider,
  IconButton,
  Link,
} from "@mui/material";
import { Person, AttachFile, Close } from "@mui/icons-material";
import styles from "./index.module.css";
import { logo } from "images";
import { labels } from "_utils/labels";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { getHistoryByIdApi, getInteractionHistoryDownloadApi } from "services/mapCenter/mapCenter.thunks";
import { ERR_MSG, INTERACTION_HIST } from "constants/labels";
import { useDispatch } from "react-redux";
import { alertActions } from "_store";
import dayjs from "dayjs";

const ViewHistory = ({ open, setOpen, mapReqId }) => {
  const header = "Interaction History";
  const dispatch = useDispatch();
  const [interactionHistory, setInteractionHistory] = useState();
  const fetchInteractionHistory = async (mapReqId) => {
    try {
      dispatch(alertActions.clear());
      const res = await dispatch(getHistoryByIdApi(mapReqId)).unwrap();
      if (res?.Succeeded === false) {
        dispatch(
          alertActions.error({
            message: res?.Message,
            header: header,
          })
        );
        setOpen(false);
        return;
      }
      setInteractionHistory(res?.Data);
    } catch (error) {
      setOpen(false);
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header: header,
        })
      );
    }
  };
  useEffect(() => {
    if (open) {
      fetchInteractionHistory(mapReqId);
    }
  }, [mapReqId, open]);

  const handleClose = () => {
    setInteractionHistory(null);
    setOpen(false);
  };

  const formatDate = (dateString) => {
    return dayjs(dateString).format("YYYY-MM-DD hh:mm:ss A");
  };

  const handleDownload = (fileName) => {
    try {
      if (!fileName) {
        dispatch(
          alertActions.error({
            message: ERR_MSG["073"],
            header: header,
          })
        );
        return;
      }
      dispatch(
        getInteractionHistoryDownloadApi(fileName)
      ).unwrap();
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header: header,
        })
      );
    }
  };

  const contentStyle = {
    overflowY: "auto",
  };

  const userSectionStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px",
  };

  return (
    interactionHistory && (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="interaction-history-title"
        aria-describedby="interaction-history-description"
        className={styles.modalContainer}
      >
        <Box className={styles.modalBox}>
          <Box className={styles.modalBoxInner}>
            <Link href="#" variant="logo" className="wgllogo">
              <img src={logo} alt="logo"></img>
              {labels.eServicePortal}
            </Link>
            <h5 className="headercontent">
              <b>{header}</b>
            </h5>

            <Box sx={contentStyle}>
              {interactionHistory?.map((history) => (
                <>
                  <Box sx={userSectionStyle}>
                    <Avatar className={styles.customerAvatar}>
                      <Person sx={{ color: "#0d4d94" }} />
                    </Avatar>
                    <Box>
                      <Typography className={styles.customerName}>
                        {history?.AddedBy}
                      </Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ fontSize: "12px" }}
                      >
                        {formatDate(history?.DateAdded)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box className={styles.detailsBox}>
                    <Box sx={{ marginBottom: "16px" }}>
                      <Typography sx={{ fontWeight: "700", color: "#0d4d94" }}>
                        Comment:
                      </Typography>
                      <Typography variant="body2">
                        {history?.Comments}
                      </Typography>
                    </Box>

                    <Box sx={{ marginBottom: "16px" }}>
                      <Typography sx={{ fontWeight: "700", color: "#0d4d94" }}>
                        Email:
                      </Typography>
                      <Box sx={{ paddingLeft: "16px" }}>
                        <Typography
                          variant="body2"
                          sx={{ marginBottom: "4px" }}
                        >
                          <span className={styles.toSubjMsg}>To:</span>{" "}
                          {history?.EmailAddress}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ marginBottom: "4px" }}
                        >
                          <span className={styles.toSubjMsg}>Subject:</span>{" "}
                          {history?.EmailSubject}
                        </Typography>
                        <Typography variant="body2">
                          <span className={styles.toSubjMsg}>Message:</span>{" "}
                          {history?.EmailComments}
                        </Typography>
                      </Box>
                    </Box>
                    {history?.MapFileName && (
                      <>
                        <Box
                          sx={
                            history?.MapFileData !== ""
                              ? {
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }
                              : {
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  opacity: 0.5,
                                  pointerEvents: "none",
                                  userSelect: "none",
                                }
                          }
                        >
                          <FilePresentIcon
                            sx={{ fontSize: 24, color: "#0d4d94" }}
                          />
                          <Typography
                            sx={{
                              cursor: "pointer",
                              fontSize: "16px",
                            }}
                            onClick={() => handleDownload(history?.MapFileName)}
                          >
                            {history?.MapFileName?.replace(/_[^_]+(?=\.[^.]+$)/, '')}
                          </Typography>
                        </Box>
                        <Box>
                          {history?.MapFileData === "" ? (
                            <Typography
                              sx={{ fontSize: "12px", fontStyle: "italic" }}
                            >
                              {INTERACTION_HIST}
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </>
                    )}
                  </Box>
                </>
              ))}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={handleClose}
                fullWidth
                className={styles.submitButton}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    )
  );
};

export default ViewHistory;
